import { createAction, props } from '@ngrx/store';
import { Background, BetPresets, BetSizes, CardStyle, Felt, IAvatar, RaiseSizes, ThemeOptions, Transaction } from './gameThemeSettings.state';

export const setFelt = createAction(
    '[GameThemeSettings] Set felt',
    props<{
        felt: Felt;
    }>()
);

export const setUnlockedFelts = createAction(
    '[GameThemeSettings] Set unlocked felts',
    props<{
        felts: Felt[];
    }>()
);

export const setUnlockedBackgrounds = createAction(
    '[GameThemeSettings] Set unlocked backgrounds',
    props<{
        backgrounds: Background[];
    }>()
);

export const setUnlockedCardStyles = createAction(
    '[GameThemeSettings] Set unlocked card styles',
    props<{
        cardStyles: CardStyle[];
    }>()
);

export const setUnlockedAvatars = createAction(
    '[GameThemeSettings] Set unlocked avatars',
    props<{
        avatars: IAvatar[];
    }>()
);

export const setBackground = createAction(
    '[GameThemeSettings] Set background',
    props<{
        background: Background;
    }>()
);

export const setCardStyle = createAction(
    '[GameThemeSettings] Set card style',
    props<{
        cardStyle: CardStyle;
    }>()
);

export const resetSettings = createAction(
    '[GameThemeSettings] Reset settings',
);

export const setBetSizes = createAction(
    '[GameThemeSettings] Set bet sizes',
    props<{
        betSizes: BetSizes;
    }>()
);

export const setRaiseSizes = createAction(
    '[GameThemeSettings] Set raise sizes',
    props<{
        raiseSizes: RaiseSizes;
    }>()
);

export const setThemeOptions = createAction(
    '[GameThemeSettings] Set theme options',
    props<{
        optionType: keyof ThemeOptions;
        optionValue: boolean;
    }>()
);

export const setTransactions = createAction(
    '[GameThemeSettings] Set transactions',
    props<{
        transactions: Transaction[];
    }>()
);

export const setPosition = createAction(
    '[GameThemeSettings] Set position',
    props<{
        position: number;
    }>()
);

export const setBetPresets = createAction(
    '[GameThemeSettings] Set bet presets',
    props<{
        betPresets: BetPresets;
    }>()
);
